export default "__VITE_ASSET__BluYr3Jy__"